import flatpickr from "flatpickr";
import "flatpickr/dist/flatpickr.min.css";

// flatpickrを初期化するための関数を定義
const initializeFlatpickrFor = (elements) => {
  flatpickr(elements, {
    enableTime: true,
    noCalendar: true,
    dateFormat: "H:i",
    time_24hr: true,
    minuteIncrement: 30, // 15分刻みに修正
    appendTo: window.document.body,
    allowInput: true
  });
};

// ページ初回読み込み時に既存の要素を初期化
document.addEventListener('DOMContentLoaded', () => {
  const timeInputs = document.querySelectorAll('.a-time-input');
  if (timeInputs.length > 0) {
    initializeFlatpickrFor(timeInputs);
  }
});

// cocoonで新しいフォームが追加された後にも初期化を実行
// (この部分は前回と同じです)
$(document).on('cocoon:after-insert', function(e, insertedItem) {
  const timeInputs = insertedItem.find('.a-time-input');
  if (timeInputs.length > 0) {
    initializeFlatpickrFor(timeInputs);
  }
});